import { Download } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { generateMessagePdf } from '@/lib/generatePdf';

interface Props {
  messageId: string;
}

const DownloadButton = ({ messageId }: Props) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const doc = await generateMessagePdf(messageId);
      doc.save('message.pdf');
    } catch (err) {
      toast.error('Failed to download: ' + String(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={handleDownload}
            disabled={loading}
            variant="ghost"
            size="icon"
            className="text-muted-foreground"
          >
            <Download className={`h-4 w-4 ${loading ? 'animate-pulse' : ''}`} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{loading ? 'Generating PDF…' : 'Download as PDF'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export { DownloadButton };
